import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './components/App/App';
import './index.css';

import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
    <PersistGate loading={null} persistor={persistor}>
        <App />
        </PersistGate>
        <ToastContainer />
        </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

